module.exports = __webpack_public_path__ + "media/images/white-exit-eaaccabd7b87bc65fa1b7177efbe252d.svg";